import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: "fullscreen-btn w-11 h-11 flex items-center justify-center rounded-xl text-gray-600 hover:text-gray-700 dark:text-white/90 dark:hover:text-white hover:bg-gray-50 dark:hover:bg-white/10 transition-all duration-300 shadow-md hover:shadow-lg backdrop-blur-sm hover:scale-105 bg-white dark:bg-gradient-to-br dark:from-[#007aff] dark:to-[#5856d6] border border-black/10 dark:border-white/20",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleFullscreen && _ctx.toggleFullscreen(...args)))
  }, _cache[1] || (_cache[1] = [
    _createElementVNode("i", {
      class: "material-symbols-outlined text-lg",
      id: "fullscreenIcon"
    }, " fullscreen ", -1)
  ])))
}